import { render, staticRenderFns } from "./integratorsClodProduct.vue?vue&type=template&id=2ebea094&scoped=true"
import script from "./integratorsClodProduct.vue?vue&type=script&lang=js"
export * from "./integratorsClodProduct.vue?vue&type=script&lang=js"
import style0 from "./integratorsClodProduct.vue?vue&type=style&index=0&id=2ebea094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebea094",
  null
  
)

export default component.exports